var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-footer"},[_c('Button',{staticClass:"p-button-success",attrs:{"label":"OK"},on:{"click":_vm.applyDateFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }